<template>
  <v-container>
    <Navigation />
    <v-col
      cols="12"
      sm="12"
      xs="4"
      class="ml-2"
      :class="{ 'col-md-12': isChrome, 'col-md-10': isFirefox }"
    >
      <div class="container mx-5">
        <TableWithSearch
          :headers="allHeaders"
          :items="getProcess"
          :openDialog="openDialog"
          :title="title"
          :showValidateProcess="true"
          @headersUpdated="updateHeaders"
          :key="isOpenStep"
        />
      </div>
      <v-dialog v-model="showAdd" max-width="500px" persistent>
        <v-card>
          <v-card-title class="flex-center">
            {{
              isEdit
                ? $tc("workflow.edit") + " " + $tc("workflow.process")
                : $tc("workflow.add") + " " + $tc("workflow.process")
            }}
          </v-card-title>

          <v-card-actions class="flex-center">
            <v-form ref="form" v-model="valid" style="width: 100%" class="mx-2">
              <v-alert
                dense
                v-if="error"
                color="red"
                elevation="5"
                outlined
                text
                type="error"
                align="center"
                class="mr-1 ml-1"
              >
                {{ alertValidate }}</v-alert
              >
              <v-autocomplete
                outlined
                dense
                label="Tipo"
                v-model="data.type"
                :rules="rules"
                :items="typeProcess"
                @change="changeType"
                item-text="name"
                item-value="value"
              />
              <v-text-field
                v-model="data.name"
                outlined
                dense
                label="Nombre"
                :rules="rules"
              />
              <v-text-field
                v-model="data.description"
                outlined
                dense
                label="Descripción"
                :rules="rules"
              />
              <v-autocomplete
                v-if="showConcept"
                outlined
                dense
                label="Concepto"
                v-model="data.concept"
                :rules="rules"
                item-value="id"
                item-text="name"
                :items="
                  data.type === 'HSEX' ? getConceptsExtra : getConceptsLic
                "
              />
            </v-form>
          </v-card-actions>
          <div class="d-flex justify-space-between pb-2 px-5">
            <v-btn class="bt-exit mr-2 mb-2" @click="cancel"
              >{{ $tc("editRegistrations.cancel") }}
            </v-btn>
            <v-btn class="bt-acept" @click="validate">
              {{ $tc("editRegistrations.acept") }}</v-btn
            >
          </div>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showValidation" max-width="650px" persistent>
        <v-card>
          <v-card-title class="flex-center"></v-card-title>
          <v-card-text>
            <div v-if="processValidations.length > 0" type="error" outlined>
              <template v-for="(error, index) in processValidations">
                <v-alert dense :key="index" type="error" outlined>{{
                  error.error
                }}</v-alert>
              </template>
            </div>
            <v-alert v-else type="success" outlined>
              Los pasos han sido verificados con éxito.
            </v-alert>
          </v-card-text>
          <v-card-actions class="flex-center">
            <div class="flex-center">
              <v-btn class="bt-exit mr-2 mb-2" @click="cancel">{{
                $tc("newController.close")
              }}</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showDelete" max-width="300px" persistent>
        <v-card>
          <v-card-title class="flex-center">
            {{ $tc("workflow.delete") + " " + $tc("workflow.process") }}
          </v-card-title>
          <v-card-actions class="flex-center">
            <div class="flex-center">
              <v-btn class="bt-exit mr-2 mb-2" @click="cancel"
                >{{ $tc("editRegistrations.cancel") }}
              </v-btn>
              <v-btn class="bt-acept" @click="deteleProcess">
                {{ $tc("editRegistrations.acept") }}</v-btn
              >
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isLoading"
        class="dialog__loader"
        :overlay-opacity="0.3"
      >
        <Loader :loading="isLoading" />
      </v-dialog>
      <Alerts
        :alert="errorAlert"
        :color="colorError"
        :textAlert="textAlertOk"
      />
      <Alerts :alert="ok" :color="colorOk" :textAlert="textAlertOk" />
      <v-dialog
        :retain-focus="false"
        v-model="showSteps"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        scrollable
        max-width="100%"
      >
        <Steps :key="showSteps.id" />
      </v-dialog>
    </v-col>
  </v-container>
</template>

<script>
import Navigation from "../../commons/Navigation.vue";
import TableWithSearch from "../../../Complement/TableWithSearch.vue";
import process from "@/store/workflow/process";
import commons from "@/store/workflow/commons";
import Loader from "../../../Complement/Loader.vue";
import Alerts from "../../../GestionEmpleados/commons/Alerts.vue";
import Steps from "./Steps.vue";
import steps from "@/store/workflow/steps";
import attributes from "@/store/workflow/attributes";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: { Steps, Navigation, TableWithSearch, Loader, Alerts },
  data() {
    return {
      title: "Procesos",
      titleTable: "WF_Procesos",
      type: "Procesos",
      showConcept: false,
      search: "",
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
      error: false,
      alertValidate: "",
      valid: true,
      isLoading: false,
      colorError: "#FF8D58",
      colorOk: "#82A1D0",
      textAlertOk: "",
      errorAlert: false,
      data: {
        name: null,
        type: null,
        description: null,
        concept: null,
      },
      ok: false,
      showDelete: false,
      deleteItems: null,
      showValidation: false,
      headers: {
        Process: [
          {
            text: "Proceso",
            value: "name",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Descripción",
            value: "description",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
          },
          {
            text: "Tipo",
            value: "type",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
          },
          {
            text: "Acciones",
            value: "actions",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
            width: "150px",
          },
        ],
        Steps: [
          {
            text: "Orden",
            value: "id",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
          },
          {
            text: "Pasos",
            value: "name",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
          },
          {
            text: "Obligatorio",
            value: "mandatory",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
          },
          {
            text: "Suficiente",
            value: "enoght",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
          },
          {
            text: "Acciones",
            value: "actions",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
            width: "150px",
          },
        ],
      },
    };
  },

  mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          Object.values(this.allColums).reduce(
            (sum, array) => sum + array.length,
            0,
          ) !==
            Object.values(this.headers).reduce(
              (sum, array) => sum + array.length,
              0,
            )
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    this.isLoading = true;
    process.dispatch("getProcess").then(() => {
      this.isLoading = false;
    });
  },

  computed: {
    allHeaders() {
      return configTable.state.colums.Process || [];
    },
    allColums() {
      return configTable.state.colums;
    },
    getProcess() {
      return process.state.process;
    },
    typeProcess() {
      return process.state.typeProcess;
    },
    processValidations() {
      return process.state.validations;
    },
    isOpenStep() {
      return process.state.showSteps;
    },
    isEdit: {
      get() {
        return commons.state.isEdit;
      },
      set(newValue) {
        return newValue;
      },
    },
    showAdd: {
      get() {
        return commons.state.showAdd;
      },
      set(newValue) {
        return newValue;
      },
    },
    showSteps: {
      get() {
        return process.state.showSteps;
      },
      set(newValue) {
        return newValue;
      },
    },

    getConceptsExtra() {
      return process.state.concept.filter((e) => e.horTrab == "S" && e.id > 4);
    },
    getConceptsLic() {
      return process.state.conceptLic.filter((e) => e.id > 4);
    },
    isChrome() {
      return (
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor)
      );
    },
    isFirefox() {
      return /Firefox/.test(navigator.userAgent);
    },
  },
  methods: {
    updateHeaders(headers) {
      const updatedColums = {
        ...configTable.state.colums,
        Process: headers,
      };

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        Object.values(this.allColums).reduce(
          (sum, array) => sum + array.length,
          0,
        ) !==
          Object.values(this.headers).reduce(
            (sum, array) => sum + array.length,
            0,
          ) ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    openDialog(type, item) {
      switch (type) {
        case "add":
          this.addExecution();
          break;
        case "edit":
          this.editExecution(item);
          break;
        case "delete":
          this.deleteExecution(item);
          break;
        case "validate":
          this.validateProcess();
          break;
        default:
          break;
      }
    },
    addExecution() {
      attributes.dispatch("getAttributes");
      commons.commit("setShowAdd", true);
      commons.commit("setIsEdit", false);
    },
    deleteExecution(item) {
      this.showDelete = true;
      this.deleteItems = item.id;
    },
    async editExecution(item) {
      await process.commit("setEditItems", item);
      await steps.commit("setId", item.id);
      await steps.dispatch("getProcessId");
      process.commit("setShowSteps", true);
      this.showSteps = true;
    },
    async validateProcess() {
      await process.dispatch("getValidateProcess").then(() => {
        this.showValidation = true;
      });
    },
    validate() {
      let valid = this.$refs.form.validate();

      if (valid) {
        if (this.isEdit) {
          this.edit();
        } else {
          this.add();
        }
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    cancel() {
      if (this.showAdd) {
        commons.commit("setShowAdd", false);
        this.showAdd = false;
        this.isEdit = false;
        this.$refs.form.resetValidation();
        (this.data = {
          name: null,
          type: null,
          description: null,
          concept: null,
        }),
          (this.ok = false);
        this.errorAlert = false;
      } else {
        this.showDelete = false;
        this.showValidation = false;
      }
    },

    add() {
      this.isLoading = true;
      let payload = {
        name: this.data.name,
        description: this.data.description,
        type: this.data.type,
        concept: this.data.concept,
      };
      process.commit("setNew", payload);
      process
        .dispatch("new")
        .then(() => {
          process.dispatch("getProcess");
          this.ok = true;
          this.isLoading = false;
          this.textAlertOk = "Se agrego el proceso";
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
          this.errorAlert = true;
          this.textAlertOk = e.response.data.error.message;
        });

      this.cancel();
    },

    deteleProcess() {
      this.isLoading = true;
      process.commit("setDeleteItem", this.deleteItems);
      process
        .dispatch("delete")
        .then(() => {
          this.ok = true;
          this.isLoading = false;
          this.textAlertOk = "Se elimino el proceso";
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
          this.errorAlert = true;
          this.textAlertOk = e.response.data.error.message;
        });

      this.cancel();
    },
    // cambia de tipo de concepto
    changeType(item) {
      process.dispatch("getConceptLic");
      process.dispatch("getConcept").then(() => {
        switch (item) {
          case "CHOR":
            this.showConcept = false;
            break;
          case "LICE":
            this.showConcept = true;
            break;
          case "HSEX":
            this.showConcept = true;

            break;
          case "LICF":
            this.showConcept = false;
            break;
          case "DELE":
            this.showConcept = false;
            break;

          default:
            break;
        }
      });
    },
  },
};
</script>

<style scoped>
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}

.flex-center {
  display: flex;
  justify-content: center;
}
.container {
  max-width: 100%;
}
</style>
